import { render, staticRenderFns } from "./updHuisProp1.vue?vue&type=template&id=10b47022"
import script from "./updHuisProp1.vue?vue&type=script&lang=js"
export * from "./updHuisProp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports